<template>
    <div class="calculator-documents">
        <div>
            <a :href="document.link" :title="document.name" @click="$emit('rmkLayout', 3)" target="_blank"
               v-for="document in constructionDocuments">{{document.name}}</a>
        </div>
        <div>
            <button class="button--link" v-on:click="createPdf()">
                {{processing ? 'Vytvářím soupis materiálu...' : 'Soupis materiálu (PDF)'}}
            </button>
        </div>
        <calculation-download-dialog v-if="url" :download-url="url"></calculation-download-dialog>
        <div class="clearfix"></div>
        <div v-if="error">
            Požadavek se nepodařilo dokončit, zkuste to, prosím, znovu.
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {createClientPdf} from '../../../api/calculator';
    import {pushGTM} from '../../../../../helpers/gtm';
    import CalculationDownloadDialog from "../control/DownloadDialog";

    export default {
      name: 'CalculationDocuments',
      components: { CalculationDownloadDialog },
      computed: {
        ...mapGetters('calculation', ['constructionDocuments', 'requestParameters'])
      },
      data() {
        return {
          error: false,
          processing: false,
          url: null,
        }
      },
      methods: {
        ...mapActions('calculation', ['setDemandWithWork']),
        setDemandAsWorkIncluded(){
          this.setDemandWithWork(true);
          this.$router.push({name: 'calculation.demandInformationIncludingWork'});
        },
        createPdf() {
            const requestData = this.requestParameters('pdf');
            this.processing = true;
            this.error = false;
            this.url = null;
            this.$emit('rmkLayout', 2);
            createClientPdf(requestData)
                .then((data) => {
                    const {path} = data;
                    this.url = path;
                    requestData.type === 'pdf' ?
                        pushGTM('Shopping list - sent', 'Shopping list sent') :
                        pushGTM('Shopping list - created', 'New shopping list');
                })
                .catch(() => this.error = true)
                .finally(() => this.processing = false);
        },
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/document/Documents.vue